export default __webpack_public_path__ + "static/media/mainimage.6720d659.jpg";